import React from 'react';
import { useLocation } from 'react-router-dom';
import ROUTE_NAME from '../../routes/RouteName';

const HeaderBackground = () => {
    const location = useLocation();
    
    switch (location.pathname) {
        case ROUTE_NAME.INVEST_NOW:
        case ROUTE_NAME.INVEST_NOW_MANUAL:
        case ROUTE_NAME.INVEST_NOW_HISTORY:
        case ROUTE_NAME.PERFORMANCE:
        case ROUTE_NAME.PORTFOLIO:
        case ROUTE_NAME.TRANSACTION:
        case ROUTE_NAME.PROFILE:
            return <div className="header-background" />;
        default:
            return null;
    }
};

export default HeaderBackground;
